var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var StrategyDistributeService = /** @class */ (function () {
    function StrategyDistributeService() {
    }
    /**
     * 手动执行策略分案
     */
    StrategyDistributeService.prototype.manualExecuteStrategy = function (type, loading) {
        return this.netService.send({
            server: dataimpService.strategyDistributeController.manualExecuteStrategy,
            data: {
                type: type
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], StrategyDistributeService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], StrategyDistributeService.prototype, "manualExecuteStrategy", null);
    return StrategyDistributeService;
}());
export { StrategyDistributeService };
